import { ReactiveSet } from "@solid-primitives/set";

type Env = {
	DEV: boolean;
};

export const allFlags = [
	{
		id: "dev",
	},
	{
		id: "message_search",
	},
	{
		id: "room_member_list",
	},
	{
		id: "channel_member_list",
	},
	{
		id: "service_worker_media",
	},
	{
		id: "inbox",
	},
	{
		id: "friends",
	},
	{
		id: "two_tier_nav",
	},
	{
		id: "nav_header",
	},
	{
		id: "voice_music",
	},
	{ id: "thread_quick_create" },
	{ id: "channel_forum" },
	{ id: "channel_calendar" },
	{ id: "channel_documents" },
	{ id: "channel_script" },
	{ id: "automod" },
	{ id: "auto_redirect_last_channel" },
	{ id: "markdown_code_components" },
	{ id: "markdown_html_preview" },
	{ id: "markdown_rust_playground" },
	{ id: "msgpack" },
	{ id: "sync_deflate" },
	{ id: "channel_create_private" },
	{ id: "channel_tickets" },
	{ id: "channel_info" },
	{ id: "media_three" },
	{ id: "code_color_preview" },
	{ id: "nsfw_blur" },
	{ id: "media_sidebar" },
	{ id: "auth_totp" },
	{ id: "auth_webauthn" },
	{ id: "themes" },
	{ id: "sync_webtransport" },
	{ id: "search_refactor" },
] as const;

type Flag = (typeof allFlags)[number]["id"];

const flagsDev: Flag[] = [
	"dev",
	"message_search",
	"room_member_list",
	"channel_member_list",
	"service_worker_media",
	"inbox",
	"friends",
	"two_tier_nav",
	"nav_header",
	"voice_music",
	"thread_quick_create",
	"channel_forum",
	"channel_calendar",
	"channel_documents",
	"channel_script",
	"automod",
	"markdown_code_components",
	"markdown_html_preview",
	"markdown_rust_playground",
	"msgpack",
	"sync_deflate",
	"channel_create_private",
	"channel_tickets",
	"media_three",
	"code_color_preview",
	"channel_info",
	"nsfw_blur",
	"media_sidebar",
	"auth_totp",
	"auth_webauthn",
	"themes",
	"sync_webtransport",
	"search_refactor",
];

const flagsProd: Flag[] = [
	"service_worker_media",
	"room_member_list",
	"channel_member_list",
	"two_tier_nav",
	"message_search",
	"nav_header",
	"msgpack",
	"sync_deflate",
	"nsfw_blur",
	"automod",
	"markdown_code_components",
	"media_three",
	"inbox",
	"sync_webtransport",
	"friends",
	"channel_forum",
];

export const flags = new ReactiveSet(
	(import.meta as unknown as { env?: { DEV?: boolean } }).env?.DEV
		? flagsDev
		: flagsProd,
);
